import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import LoggedInLayout from "../../layouts/loggedinlayout";
import AccountInformation from "./accountinformation";
import ChangePassword from "./ChangePassword";
import ServiceStatus from "./servicestatus";

const Settings = (props) => {
  const [loading, setLoading] = useState(false);
  return (
    <LoggedInLayout title="Settings" isLoading={loading}>
      <Row>
        <Col>
          <AccountInformation {...props} setLoading={setLoading} />
        </Col>
        <Col className="mt-4 mt-sm-0">
          <ChangePassword {...props} setLoading={setLoading}></ChangePassword>{" "}
        </Col>
        <Col className="mt-4 mt-sm-0">
          <ServiceStatus {...props}></ServiceStatus>{" "}
        </Col>
      </Row>
    </LoggedInLayout>
  );
};

export default Settings;
